<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.onOff')" position="top">
                <vs-switch v-model="onOff" vs-icon-off="close" vs-icon-on="done" class="mt-3">
                </vs-switch>

            </vx-tooltip>
            <vx-tooltip class="position-icon mt-1" :text="$t('button.getQRCode')" position="top">
                <feather-icon icon="CodepenIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openGetPopupQR"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon mt-1" :text="$t('button.edit')" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon mt-1" :text="$t('button.delete')" position="top"
                        v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo" title="Thông tin chi nhánh" :active.sync="popupDetailStudent"
                  v-if="popupDetailStudent" id="details-student">
            <StudentInfomation :branchId="params.data.organizationBranchId" :student-id="params.data.id">
            </StudentInfomation>
        </vs-popup>
        <vs-popup title="Mã QR" :active.sync="openPopupQRcode" v-if="openPopupQRcode">
            <div class="vx-row">
                <div class="vx-col w-full text-center">
                    <div :id="`qr-code-student-${params.data.id}`" class="flex flex-col justify-center">
                        <vue-qr :logoSrc="logo" :text="qrCodeInfo" :size="400"></vue-qr>

                        <vs-button class="btn-download-qr mt-8" @click="dowloadQRCode"
                        >{{ this.$t('qrCode.download') }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import {isAPI} from "../../../../store/permission"
import {constAPI} from "../../../../store/constant"
import StudentInfomation from "../StudentInfomation"
import VueQr from 'vue-qr'
import Logo from '../../../../assets/images/logo/img_mask.png'

export default {
    name: 'CellRendererActions',
    components: {
        StudentInfomation,
        VueQr,
        Logo
    },
    data() {
        return {
            status: true,
            popupDetailStudent: false,
            openPopupQRcode: false,
            organizationId: null,
            qrCodeInfo: null,
            logo: Logo
        }
    },
    created() {
        this.status = this.params.data.enabled
    },
    computed: {
        onOff: {
            get() {
                return this.status
            },
            set() {
                this.turnOnOff(!this.status)

            }
        },


    },
    methods: {
        isPermissionDelete() {
            return isAPI(this, constAPI.student_delete)
        },
        async openGetPopupQR() {
            await this.getQRcode();
            this.openPopupQRcode = true;
        },
        dowloadQRCode() {
            let src = document.getElementById(`qr-code-student-${this.params.data.id}`).getElementsByTagName('img')[0].src;
            this.downloadBase64File(src, "QR-Code");
        },
        downloadBase64File(contentBase64, fileName) {
            let downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.href = contentBase64;
            downloadLink.target = '_self';
            downloadLink.download = fileName;
            downloadLink.click();
            downloadLink.remove();
        },
        turnOnOff(enabled) {
            this.params.data.enabled = enabled
            if (!this.params.data.classIds) this.params.data.classIds = []
            this.$vs.loading()
            this.$crm.post(`/school-student/update/${this.params.data.id}`, this.params.data).then(() => {
                this.status = enabled
                this.$vs.notify({
                    color: 'success',
                    text: 'Cập nhật thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('UPDATE_STUDENT', true);
                this.$vs.loading.close()
            }).catch(err => {
                this.params.data.enabled = !enabled
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        editRecord() {
            // this.$router.push(`/user/student-infomation?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch(() => {
            // })
            this.popupDetailStudent = true
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá học viên "${this.params.data.fullName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/school-student/delete', [this.params.data.id]).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_STUDENT', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-check-circle',
            })
        },
        getQRcode() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                this.organizationId = userInfo.organization.id,
                    this.$vs.loading();
                this.$oauth.get(`/user/get-user-info/${this.params.data.id}?type=3&organizationId=${this.organizationId}`).then((res) => {
                    this.qrCodeInfo = JSON.stringify(res.data);
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },

    mounted() {
        this.$eventBus.$on('update-student', async () => {
            this.popupDetailStudent = false
            if (document.getElementById('details-student')) {
                document.getElementById('details-student').remove()
            }
            this.$store.commit('UPDATE_STUDENT', true);
        })
    }
}
</script>

<style lang="scss">
#details-student {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
